/**
 * Frontend mirror of the backend permission catalogue (HOMCO-1227).
 *
 * Source of truth, backend:
 *   apps/backend-homere-connect/src/rights-profiles/domains/entities/permission-catalogue.ts  (LineId)
 *   apps/backend-homere-connect/src/rights-profiles/domains/entities/permission-action.enum.ts (PermissionAction)
 *
 * These are a compile-time convenience (call-site type-safety + autocomplete) —
 * `can()` never enumerates them at runtime. The backend already flattens the
 * hierarchy, so the frontend only reads `can(line, action)` and never walks parents.
 * Re-sync this file when the backend catalogue grows (openspec change
 * homco-326-rbac-align-model-to-nav-spec, design §6).
 */

export const PERMISSION_ACTIONS = ['display', 'create', 'modify', 'delete', 'export'] as const;
export type PermissionAction = (typeof PERMISSION_ACTIONS)[number];

export const LINE_IDS = [
  'user_menu',
  'user_menu.help',
  'employee_list',
  'employee_record',
  'employee_record.identity',
  'employee_record.contract',
  'employee_record.skills',
  'employee_record.career_training',
  'employee_record.evaluation',
  'employee_record.leaves_absences',
  'employee_record.payment',
  'leave_list',
  'payslip_list',
  'general_settings',
  'rights_profiles',
  'users',
  'instances',
] as const;
export type LineId = (typeof LINE_IDS)[number];

/**
 * Flat effective rights served by `GET /auth/me`: the granted actions per catalogue
 * line. A line with nothing granted is absent (never an empty array) — so
 * `permissions?.[line]?.includes(action) ?? false` is a complete membership test.
 */
export type ResolvedPermissions = Partial<Record<LineId, PermissionAction[]>>;
